import { render, staticRenderFns } from "./MyPaymentsTable.vue?vue&type=template&id=1f117468&scoped=true"
import script from "./MyPaymentsTable.vue?vue&type=script&lang=js"
export * from "./MyPaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./MyPaymentsTable.vue?vue&type=style&index=0&id=1f117468&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f117468",
  null
  
)

export default component.exports